import { GraphQLError } from 'graphql';

export interface ValidationError {
  property: string;
  messages: string[];
}

export function getLocaleErrorMessageName(e: any) {
  const s = e.graphQLErrors[0].extensions.code;
  return 'errors.filter;';
}

export function errorCodes(e: Readonly<GraphQLError[]>): string[] {
  return e.map((e) => e.extensions?.code).filter((c) => c !== undefined);
}

export function errorCode(e: any): string | undefined {
  const graphQLError = e.graphQLErrors && e.graphQLErrors[0];
  if (graphQLError) {
    let s: string | undefined = graphQLError.extensions && graphQLError.extensions.code;
    if (s === 'BAD_USER_INPUT') {
      s = graphQLError.extensions.errors[0].extensions.code || s;
    }
    return s;
  }
  return undefined;
}

export function isRateLimited(e: any) {
  return errorCode(e) === 'RateLimiterError';
}

export function getLocaleErrorMessage(e: any) {
  return '';
}

export function extractValidationErrorMessages(errors: Readonly<GraphQLError[]>): ValidationError[] {
  return errors
    .flatMap((e) => (e.extensions?.code === 'BAD_USER_INPUT' && e.extensions?.validationErrors) || [])
    .map((e) => ({
      property: e.property as string,
      messages: Object.values(e.constraints) as string[],
    }));
}

export function getStripeMessageFromError(errors: Readonly<GraphQLError[]>): string | undefined {
  return errors.find((e) => e.extensions?.code === 'STRIPE_ERROR')?.message;
}

export class UnexpectedError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'UnexpectedError';
  }
}
